module.exports = __webpack_public_path__ + "assets/operate.4fa93c42.svg";